import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/react'
import { colors } from '../../../../utilities/colors'
import QuoteSummary from '../QuoteSummary'
import { locationTypeLabels } from '../../../../constants/carpoolLocation'

export default function ReviewStep({ origin, destination, units, allOperable }) {
  const { t } = useTranslation()

  const isManualLocation = (loc) => loc?.type && loc.type !== 'Auction' && loc.type !== 'DealerPlace'

  const decorateLocation = (loc) => {
    if (!isManualLocation(loc)) return loc
    const typeLabel = t(locationTypeLabels[loc.type] || loc.type)
    return { ...loc, name: t('Custom {{type}} Address', { type: typeLabel }) }
  }

  const vehicles = units.map((u) => ({
    id: u.id,
    vin: u.attributes.vin,
    year: u.attributes.year,
    make: u.attributes.make,
    model: u.attributes.model,
    inoperable: !allOperable,
  }))

  return (
    <Box display="flex" flexDirection="column" w="full" gap={4}>
      <QuoteSummary origin={decorateLocation(origin)} destination={decorateLocation(destination)} vehicles={vehicles} stackLocations />
      <Text fontSize="xs" color={colors.grey300} textAlign="center">
        {t('Confirm to get your shipping options.')}
      </Text>
    </Box>
  )
}
